import { Linking, Platform } from 'react-native';

let expoLinkRead = false;

/**
 * The link that launched the app, if one did.
 *
 * iOS: CarPlay puts the app on scenes, so a launching link reaches
 * MainSceneDelegate (plugins/withCarPlay.js) and never appears in launchOptions,
 * the only place React Native's getInitialURL looks. The delegate hands it to
 * Expo, whose linking module keeps it. Expo keeps the latest link it saw, not
 * only the launching one, so it is read once: a remount must not replay a
 * sign-in ticket.
 */
export async function getInitialLinkUrl(): Promise<string | null> {
  const url = await Linking.getInitialURL();
  if (url || Platform.OS !== 'ios' || expoLinkRead) return url;
  expoLinkRead = true;
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require('expo-linking').getLinkingURL();
  } catch {
    return null;
  }
}
